import React, { useEffect } from 'react';
import { FormSection } from './profile.styled';
import TwoFaForm from '../components/profile/twoFA';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as ActionCreators from '../redux/action';

function TwoFA({ fetchUserData }) {
  useEffect(() => {
    fetchUserData();
  }, [fetchUserData]);

  return (
    <div className="container">
      <FormSection id="2fa-options">
        <TwoFaForm />
      </FormSection>
    </div>
  );
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      fetchUserData: ActionCreators.fetchUserData
    },
    dispatch
  );

export default connect(
  undefined,
  mapDispatchToProps
)(TwoFA);
